import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

export interface AuthSate {
    token: string | null;
    name: string | null;
    role: number | null;
}

const user = JSON.parse(localStorage.getItem('user') ?? '{}');

const initialState: AuthSate = {
    token: user?.token ?? null,
    role: user?.role ?? null,
    name: user?.name ?? null,
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setUser: (state, action: PayloadAction<AuthSate>) => {
            localStorage.setItem(
                'user',
                JSON.stringify({
                    token: action.payload.token,
                    role: action.payload.role,
                    name: action.payload.name,
                }),
            );
            state.token = action.payload.token;
            state.role = action.payload.role;
            state.name = action.payload.name;
        },
        logout: (state) => {
            localStorage.clear();
            state.token = null;
            state.role = null;
            state.name = null;
        },
    },
});

export const selectAuth = (state: RootState) => state.auth;

export const { setUser, logout } = authSlice.actions;

export default authSlice.reducer;
